import RecipeReviewer from "@/views/pages/Recipe/RecipeReviewer";
import ExtraSelection from "../ExtrasSelection";
import ProductDescription from "../ProductDescription";
import { uuid } from "vue-uuid";
import { addToCart } from "@/api/Cart";
/* eslint-disable */
export default {
  components: {
    ExtraSelection,
    RecipeReviewer,
    ProductDescription,
  },
  data() {
    return {
      productPlaceHolder: require("@/assets/images/products/product-kahve.png"),
      isExtraSelectionOpen: false,
      quantity: 1,
      weight: 0,
      rawMaterials: [],
      selectedRecipe: {},
      productName: [""],
      isVariantSelectionOpen: false,
      selectedRawMaterial: null,
      isRawMaterialsReload: true,
      selectedExtras: [],
      isNotePopupOpen: false,
      note: "",
      isMobile: null,
    };
  },
  computed: {
    realSelectedExtras() {
      let returnObj = [];
      this.selectedExtras.filter((x) => {
        if (x.quantity > 0) {
          returnObj.push(x);
        } else if (x.variants != null && x.variants.length > 0) {
          if (x.variants.some((z) => z.quantity > 0)) {
            x.variants
              .filter((y) => y.quantity > 0)
              .forEach((variantExtra) => {
                returnObj.push(variantExtra);
              });
          }
        }
      });
      return returnObj.length > 0 ? returnObj : null;
    },
    currentCart: function () {
      return this.$store.getters["selfservice/getCurrentCart"];
    },
    toUpdateEntry() {
      return this.$store.getters["selfservice/getToUpdateEntry"];
    },
    selectedProduct: function () {
      return this.$store.getters["selfservice/getSelectedProduct"];
    },
    activeCart: function () {
      return this.$store.getters["selfservice/getCurrentCart"];
    },
    description: function () {
      if (this.selectedProduct == null) {
        if (
          !this.toUpdateEntry.rawProduct ||
          !this.toUpdateEntry.rawProduct.children
        )
          return "";
        const selectedChild = this.toUpdateEntry.rawProduct.children.find(
          (x) => x.isSelected
        );
        return selectedChild ? selectedChild.description || "" : "";
      } else {
        if (!this.selectedProduct || !this.selectedProduct.children) return "";
        const selectedChild = this.selectedProduct.children.find(
          (x) => x.isSelected
        );
        return selectedChild ? selectedChild.description || "" : "";
      }
    },
    currentTab: {
      get() {
        return this.$store.getters["selfservice/getCurrentTab"];
      },
    },
    isWeightProduct() {
      if (this.selectedProduct) {
        return this.selectedProduct.isWeight || (this.selectedProduct.children && this.selectedProduct.children.some(child => child.isWeight));
      }
      if (this.toUpdateEntry && this.toUpdateEntry.rawProduct) {
        return this.toUpdateEntry.rawProduct.isWeight || (this.toUpdateEntry.rawProduct.children && this.toUpdateEntry.rawProduct.children.some(child => child.isWeight));
      }
      return false;
    },
    isTimeProduct() {
      if (this.selectedProduct) {
        return this.selectedProduct.isTime || (this.selectedProduct.children && this.selectedProduct.children.some(child => child.isTime));
      }
      if (this.toUpdateEntry && this.toUpdateEntry.rawProduct) {
        return this.toUpdateEntry.rawProduct.isTime || (this.toUpdateEntry.rawProduct.children && this.toUpdateEntry.rawProduct.children.some(child => child.isTime));
      }
      return false;
    },
    isGramPricing() {
      if (this.selectedProduct) {
        if (this.selectedProduct.children) {
          const selectedChild = this.selectedProduct.children.find(child => child.isSelected);
          if (selectedChild && selectedChild.isGr !== undefined) return selectedChild.isGr;
        }
      }
      if (this.toUpdateEntry && this.toUpdateEntry.rawProduct) {
        if (this.toUpdateEntry.rawProduct.isGr !== undefined) return this.toUpdateEntry.rawProduct.isGr;
        if (this.toUpdateEntry.rawProduct.children) {
          const selectedChild = this.toUpdateEntry.rawProduct.children.find(child => child.isSelected);
          if (selectedChild && selectedChild.isGr !== undefined) return selectedChild.isGr;
        }
      }
      return false;
    },
    calculatedPrice() {
      let basePrice = this.selectedRecipe.price;

      // Add extras price
      if (this.realSelectedExtras) {
        this.realSelectedExtras.forEach((extra) => {
          basePrice += extra.quantity * extra.price;
        });
      }

      // Calculate weight-based price if it's a weight product
      if (this.isWeightProduct && this.weight > 0) {
        console.log(this.isGramPricing);
        if (this.isGramPricing) {
          // Price is per gram, weight is in kg, multiply by 1000 and quantity
          basePrice = basePrice * this.weight * 1000 * this.quantity;
        } else {
          // Price is per kg, weight is in kg, multiply by quantity
          basePrice = basePrice * this.weight * this.quantity;
        }
      } else {
        // Regular quantity-based pricing
        basePrice = basePrice * this.quantity;
      }

      return basePrice;
    },
  },
  created: function () {
    this.checkScreen();
    window.addEventListener("resize", this.checkScreen);
    if (!this.toUpdateEntry) {
      this.selectedRecipe = this.findSelectedProductInDeep(
        this.selectedProduct
      );
      this.selectedRecipe.image = this.selectedProduct.imageUrl;
    } else {
      this.selectedRecipe = this.findSelectedProductInDeep(
        this.toUpdateEntry.rawProduct
      );
      this.selectedRecipe.recipeSteps.forEach((step) => {
        step.isRemoved = this.toUpdateEntry.recipe.steps.find(
          (x) => x.stepId === step.id
        ).isRemoved;
        step.isRemovable = this.toUpdateEntry.recipe.steps.find(
          (x) => x.stepId === step.id
        ).isRemovable;
      });
      this.selectedRecipe.image = this.toUpdateEntry.rawProduct.imageUrl;
      this.quantity = this.toUpdateEntry.quantity;
      this.weight = this.toUpdateEntry.weight || 0;
      this.productId = this.toUpdateEntry.productId;
      this.childProductId = this.toUpdateEntry.childProductId;
      this.selectedExtras = this.toUpdateEntry.extras;
      this.setSelectedVariant();
      if (this.toUpdateEntry.note) {
        this.note = this.toUpdateEntry.note;
      }
    }
  },
  watch: {
    isVariantSelectionOpen: function (val) {
      if (!val) {
        this.selectedRawMaterial = null;
      }
    },
    toUpdateEntry: {
      handler(val) {
        this.productName = [""];
        this.selectedRecipe = this.findSelectedProductInDeep(
          this.toUpdateEntry.rawProduct
        );
        this.selectedRecipe.recipeSteps.forEach((step) => {
          step.isRemoved = this.toUpdateEntry.recipe.steps.find(
            (x) => x.stepId === step.id
          ).isRemoved;
        });
        this.quantity = this.toUpdateEntry.quantity;
        this.weight = this.toUpdateEntry.weight || 0;
        this.productId = this.toUpdateEntry.productId;
        this.childProductId = this.toUpdateEntry.childProductId;
        this.selectedExtras = this.toUpdateEntry.extras;
        this.selectedRecipe.price = val.price;
        this.setSelectedVariant();
        if (val.note) {
          this.note = val.note;
        }
      },
      deep: true,
    },
  },
  methods: {
    checkScreen() {
      this.isMobile = window.innerWidth <= 768;
    },
    validateQuantity() {
      // Ensure quantity is a positive integer
      if (isNaN(this.quantity) || this.quantity < 1) {
        this.quantity = 1;
      } else {
        // Round to the nearest integer
        this.quantity = Math.floor(this.quantity);
      }
    },
    validateWeight() {
      // Ensure weight is a positive number
      if (isNaN(this.weight) || this.weight < 0) {
        this.weight = 0;
      }
      // Round to 3 decimal places
      this.weight = Math.round(this.weight * 1000) / 1000;
    },
    async getWeightFromScale() {
      try {
        const response = await this.$http.get('http://localhost:6006/api/Terazi/weight');
        if (response.data && response.data.weight !== undefined) {
          this.weight = parseFloat(response.data.weight);
          this.$vs.notify({
            title: 'Başarılı',
            text: `Ağırlık teraziden alındı: ${this.weight} kg`,
            color: 'success'
          });
        }
      } catch (error) {
        console.error('Terazi hatası:', error);
        this.$vs.notify({
          title: 'Hata',
          text: 'Teraziden ağırlık alınamadı. Lütfen tekrar deneyin.',
          color: 'danger'
        });
      }
    },
    openNotePopup() {
      this.isNotePopupOpen = true;
    },
    saveNote() {
      this.isNotePopupOpen = false;
    },
    removeRecipeStep(step) {
      step.isRemoved = !step.isRemoved;
    },
    toggleRecipeStep(recipeStep) {
      recipeStep.isRemoved = !recipeStep.isRemoved;
    },
    openRecipeReviewer() {
      this.$refs.recipeReviewer.recipe = this.selectedRecipe;
      this.$refs.recipeReviewer.isActive = true;
    },
    openDescription() {
      this.$refs.productDescription.isActive = true;
      this.$refs.productDescription.description = this.description;
      this.$refs.productDescription.image =
        this.selectedProduct && this.selectedProduct.imageUrl
          ? this.$baseUrl + "/" + this.selectedProduct.imageUrl
          : this.toUpdateEntry && this.toUpdateEntry.rawProduct.imageUrl
            ? this.$baseUrl + "/" + this.toUpdateEntry.rawProduct.imageUrl
            : this.productPlaceHolder;
    },
    setSelectedVariant() {
      this.toUpdateEntry.recipe.steps.forEach((step) => {
        let raw = this.selectedRecipe.recipeSteps.find(
          (x) => x.rawMaterial.id == step.originRawMaterialId
        );
        if (raw) {
          let selectedVariant = raw.rawMaterial.variants.find(
            (y) => y.id == step.id
          );
          selectedVariant.selected = true;
        }
      });
    },
    resetCartEntry() {
      this.selectedRecipe.recipeSteps.forEach((x) => {
        x.rawMaterial.variants.forEach((v) => {
          v.selected = false;
        });
      });
    },
    calculateUpdateCartEntry() {
      let tempEntry = {};
      tempEntry.categories = _.cloneDeep(this.toUpdateEntry.categories);
      tempEntry.id = this.toUpdateEntry.id;
      tempEntry.quantity = this.quantity;
      tempEntry.productQuantity = this.quantity;
      tempEntry.weight = this.isWeightProduct ? this.weight : null;
      tempEntry.productId = this.toUpdateEntry.productId;
      tempEntry.productSize = this.toUpdateEntry.productSize;
      tempEntry.childProductId = this.toUpdateEntry.childProductId;
      tempEntry.extras = this.selectedExtras;

      // Süreli ürün alanlarını mevcut değerlerle koru
      tempEntry.isTime = this.toUpdateEntry.isTime || false;
      if (tempEntry.isTime) {
        tempEntry.startTime = this.toUpdateEntry.startTime;
        tempEntry.endTime = this.toUpdateEntry.endTime;
        tempEntry.hourPrice = this.toUpdateEntry.hourPrice;
        tempEntry.isRunning = this.toUpdateEntry.isRunning;
        tempEntry.totalHour = this.toUpdateEntry.totalHour;
        tempEntry.lastStartTime = this.toUpdateEntry.lastStartTime;
        tempEntry.lastStopTime = this.toUpdateEntry.lastStopTime;
      }
      tempEntry.productName = this.toUpdateEntry.productName;
      tempEntry.userName = this.$store.getters["selfservice/getActivePersonal"]
        ? `${this.$store.getters["selfservice/getActivePersonal"].name} ${this.$store.getters["selfservice/getActivePersonal"].surname}`
        : "Sistem";
      tempEntry.createdDate = new Date().toISOString();

      // Add weight to product name if it's a weight product
      if (this.isWeightProduct && this.weight > 0) {
        tempEntry.productName += ` (${this.weight} kg)`;
      }

      tempEntry.note = this.note;
      tempEntry.recipe = {
        id: this.selectedRecipe.id,
        steps: [],
      };
      this.selectedRecipe.recipeSteps.forEach((step) => {
        let tempVariant = null;
        if (
          step.rawMaterial != null &&
          step.rawMaterial.variants != null &&
          step.rawMaterial.variants.length > 0
        ) {
          tempVariant = this.getSelectedVariant(step.rawMaterial.variants);
          tempVariant.stepId = step.id;
          tempVariant.isRemoved = step.isRemoved;
          tempVariant.isRemovable = step.isRemovable;
          tempEntry.recipe.steps.push(tempVariant);
        } else {
          tempVariant = _.cloneDeep(step.rawMaterial);
          tempVariant.stepId = step.id;
          tempVariant.isRemoved = step.isRemoved;
          tempVariant.isRemovable = step.isRemovable;
          tempEntry.recipe.steps.push(tempVariant);
        }
      });
      tempEntry.steps = tempEntry.recipe.steps;
      tempEntry.recipeSteps = tempEntry.recipe.steps;
      tempEntry.price = this.selectedRecipe.price;

      // Add extras price
      if (tempEntry.extras && tempEntry.extras.length > 0) {
        tempEntry.extras.forEach((extra) => {
          if (extra.variants != null && extra.variants.length > 0) {
            extra.variants.forEach((extraVariant) => {
              if (extraVariant.quantity > 0)
                tempEntry.price =
                  tempEntry.price + extraVariant.price * extraVariant.quantity;
            });
          } else
            tempEntry.price = tempEntry.price + extra.quantity * extra.price;
        });
      }

      // Calculate base price per unit (weight-based or regular)
      if (this.isWeightProduct && this.weight > 0) {
        if (this.isGramPricing) {
          // Price is per gram, weight is in kg, multiply by 1000
          tempEntry.price = tempEntry.price * this.weight * 1000;
        } else {
          // Price is per kg, weight is in kg
          tempEntry.price = tempEntry.price * this.weight;
        }
      }
      // Note: quantity multiplication will be done in AddToCart method
      return tempEntry;
    },
    calculateCartEntry: async function () {
      let tempEntry = {};
      tempEntry.categories = _.cloneDeep(this.selectedProduct.categories);
      tempEntry.id = uuid.v1();
      tempEntry.quantity = this.quantity;
      tempEntry.productQuantity = this.quantity;
      tempEntry.weight = this.isWeightProduct ? this.weight : null;
      tempEntry.isGr = this.isGramPricing;
      tempEntry.productSize = this.selectedProduct.sizeId;
      tempEntry.productId = this.selectedProduct.id;
      tempEntry.childProductId = this.childProduct.id;
      tempEntry.extras = this.selectedExtras;

      // Süreli ürün alanları
      tempEntry.isTime = this.isTimeProduct;
      if (this.isTimeProduct) {
        const now = new Date();
        tempEntry.startTime = now.toISOString();
        tempEntry.endTime = null;
        tempEntry.hourPrice = this.selectedRecipe.price;
        tempEntry.isRunning = true;
        tempEntry.totalHour = null;
        tempEntry.lastStartTime = now.toISOString();
        tempEntry.lastStopTime = null;
      }
      tempEntry.productName = this.productName.join("->").slice(2);
      tempEntry.userName = this.$store.getters["selfservice/getActivePersonal"]
        ? `${this.$store.getters["selfservice/getActivePersonal"].name} ${this.$store.getters["selfservice/getActivePersonal"].surname}`
        : "Sistem";
      tempEntry.createdDate = new Date().toISOString();

      // Add weight to product name if it's a weight product
      if (this.isWeightProduct && this.weight > 0) {
        tempEntry.productName += ` (${this.weight} kg)`;
      }

      tempEntry.note = this.note;
      tempEntry.recipe = {
        id: this.selectedRecipe.id,
        steps: [],
      };
      this.selectedRecipe.recipeSteps.forEach((step) => {
        let tempVariant = null;
        if (
          step.rawMaterial != null &&
          step.rawMaterial.variants != null &&
          step.rawMaterial.variants.length > 0
        ) {
          tempVariant = step.rawMaterial.variants.find(
            (x) => x.selected === true
          );
          tempVariant.isRemoved = step.isRemoved;
          tempVariant.isRemovable = step.isRemovable;
          tempVariant.stepId = step.id;
          tempVariant.selected = true;
          tempEntry.recipe.steps.push(_.cloneDeep(tempVariant));
        } else {
          tempVariant = _.cloneDeep(step.rawMaterial);
          tempVariant.isRemoved = step.isRemoved;
          tempVariant.isRemovable = step.isRemovable;
          tempVariant.stepId = step.id;
          tempEntry.recipe.steps.push(tempVariant);
        }
      });
      tempEntry.steps = tempEntry.recipe.steps;
      tempEntry.recipeSteps = tempEntry.recipe.steps;

      tempEntry.price = this.selectedRecipe.price;
      tempEntry.kdv = this.childProduct.kdv;

      // Add extras price
      if (tempEntry.extras && tempEntry.extras.length > 0) {
        tempEntry.extras.forEach((extra) => {
          if (extra.variants != null && extra.variants.length > 0) {
            extra.variants.forEach((extraVariant) => {
              if (extraVariant.quantity > 0)
                tempEntry.price =
                  tempEntry.price + extraVariant.price * extraVariant.quantity;
            });
          } else
            tempEntry.price = tempEntry.price + extra.quantity * extra.price;
        });
      }

      // Calculate base price per unit (weight-based or regular)
      if (this.isWeightProduct && this.weight > 0) {
        console.log(this.isGramPricing);
        if (this.isGramPricing) {
          // Price is per gram, weight is in kg, multiply by 1000
          tempEntry.price = tempEntry.price * this.weight * 1000;
        } else {
          // Price is per kg, weight is in kg
          tempEntry.price = tempEntry.price * this.weight;
        }
      }
      if (this.isTimeProduct) {
        debugger;
        tempEntry.price = Math.round((tempEntry.price / 60) * 100) / 100;
      }
      // Note: quantity multiplication will be done in AddToCart method
      return tempEntry;
    },
    AddToCart: async function (isTemp = false) {
      console.log(this.toUpdateEntry);
      if (this.toUpdateEntry) {
        let item = this.calculateUpdateCartEntry();
        // Multiply by quantity for final price
        item.price = item.price * item.quantity;
        item.price = Math.round(item.price * 100) / 100;
        item.originPrice = item.price;
        item.rawProduct = _.cloneDeep(this.toUpdateEntry.rawProduct);
        let oldEntryIndex = this.currentCart.cartEntries.findIndex(
          (x) => x.id == item.id
        );
        let updateObj = {
          index: oldEntryIndex,
          entry: item,
        };
        this.resetCartEntry();
        this.$store.dispatch("selfservice/updateToCart", updateObj);
        let tempCart = this.$store.getters["selfservice/getCurrentCart"];
        console.log(item);
        if (this.$store.getters["selfservice/getCurrentTab"] == "odeme") {
          await addToCart(item, tempCart.tableId);
        }
        this.$store.dispatch("selfservice/setSelectedProduct", null);
        this.resetCartEntry();
        this.$emit("addToCartComplete");
      } else {
        let item = await this.calculateCartEntry();
        // Multiply by quantity for final price
        item.price = item.price * item.quantity;
        item.price = Math.round(item.price * 100) / 100;
        item.originPrice = item.price;
        item.rawProduct = _.cloneDeep(this.selectedProduct);
        console.log(this.selectedProduct);
        console.log(item);
        this.$store.dispatch("selfservice/addToCart", item);
        let tempCart = this.$store.getters["selfservice/getCurrentCart"];
        console.log(item);
        if (this.$store.getters["selfservice/getCurrentTab"] == "odeme") {
          await addToCart(item, tempCart.tableId);
        }
        this.$store.dispatch("selfservice/setSelectedProduct", null);
        this.resetCartEntry();
        this.$emit("addToCartComplete");
      }
    },
    GoToProductSelectPage: function () {
      if (this.toUpdateEntry) {
        this.resetCartEntry();
        this.$store.dispatch("selfservice/setToUpdateEntry", null);
      } else this.$store.dispatch("selfservice/setSelectedProduct", null);
    },
    getSelectedVariant: function (variants) {
      let selectedItem = variants.find((x) => x.selected == true);
      if (selectedItem == null) {
        variants.forEach((item) => {
          if (item.isDefault == true) {
            item.selected = true;
            selectedItem = item;
          } else {
            item.selected = false;
          }
        });
      }
      return _.cloneDeep(selectedItem);
    },
    findSelectedProductInDeep: function (rawProduct) {
      let product = _.cloneDeep(rawProduct);
      this.productName.push(product.name);
      if (product.children == null && product.isSelected) {
        product.recipe.price = product.price;
        this.childProduct = product;
        return product.recipe;
      } else if (product.children != null) {
        let selectedChildren = product.children.find((x) => x.isSelected);
        return this.findSelectedProductInDeep(selectedChildren);
      }
    },
    updateVariant(rawMaterial) {
      if (rawMaterial.variants != null && rawMaterial.variants.length > 0) {
        this.selectedRawMaterial = rawMaterial;
        this.isVariantSelectionOpen = true;
      }
    },
    closeVariantSelection() {
      this.isVariantSelectionOpen = false;
      this.selectedRawMaterial = null;
    },
    variantSelection(variant) {
      this.isRawMaterialsReload = false;
      this.selectedRawMaterial.variants.forEach((item) => {
        if (variant.id === item.id) {
          item.selected = true;
        } else {
          item.selected = false;
        }
      });
      this.selectedRecipe.recipeSteps
        .find((x) => x.rawMaterial.id == this.selectedRawMaterial.id)
        .rawMaterial.variants.find((y) => y.id == variant.id).selected = true;
      this.isVariantSelectionOpen = false;
      this.selectedRawMaterial = null;
      this.$nextTick(() => {
        this.isRawMaterialsReload = true;
      });
    },
    openExtraSelection() {
      this.isExtraSelectionOpen = true;
    },
    saveExtraSelection(selectedExtras) {
      this.selectedExtras = selectedExtras;
      this.isExtraSelectionOpen = false;
    },
    cancelExtraSelection() {
      this.isExtraSelectionOpen = false;
    },
  },
  destroyed: function () {
    window.removeEventListener("resize", this.checkScreen);
  },
};